export default __webpack_public_path__ + "static/media/Corona.f12d34f1.jpg";